import { render, staticRenderFns } from "./Resizable.vue?vue&type=template&id=0ed58f18&scoped=true"
import script from "./Resizable.vue?vue&type=script&lang=js"
export * from "./Resizable.vue?vue&type=script&lang=js"
import style0 from "./Resizable.vue?vue&type=style&index=0&id=0ed58f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed58f18",
  null
  
)

export default component.exports